export default "__VITE_ASSET__AgaY2qJ5__"